import React from "react";

import PropTypes from "prop-types";
import Accordion from "../../../../components/common/Accordion";

import * as S from "./AssistanceServiceSection.style";

export const servicesList = [
  {
    title: "Chaveiro",
    body: (
      <>
        Para perda, roubo ou quebra da chave de portas comuns ou da entrada
        principal da empresa, a gente envia um profissional até o local.
      </>
    ),
  },
  {
    title: "Vidraceiro",
    body: (
      <>
        Em caso de emergência, enviamos vidraceiro para consertar portas ou
        janelas externas de vidro ou cristal. Caso não seja viável fazer o
        reparo na hora do atendimento, será colocado um tapume, provisoriamente,
        até que seja possível concluir o serviço.
      </>
    ),
  },
  {
    title: "Serviço de vigilância e segurança",
    body: (
      <>
        Oferecemos vigilante por até 3(três) dias, caso a empresa fique
        vulnerável por danos causados por situações cobertas pelo seguro,
        colocando em risco os bens existentes no local.
      </>
    ),
  },
  {
    title: "Hidráulica",
    body: (
      <>
        Atendimento emergencial de um encanador para reparar vazamento
        acidental, na área interna da empresa, que cause ou possa causar um
        alagamento. Essa assistência não assume os custos de reparo completo e
        definitivo do problema, nem serviços de alvenaria ou desentupimento.
      </>
    ),
  },
  {
    title: "Indicação de profissionais",
    body: (
      <>
        Para os casos não emergenciais, quando solicitado pela pessoa segurada,
        enviaremos à empresa profissionais qualificados que possam fazer um
        orçamento.
      </>
    ),
  },
  {
    title: "Cobertura provisória de telhados",
    body: (
      <>
        Garante proteção provisória do telhado da empresa, com lona ou plástico,
        quando ele for danificado por situações cobertas pelo seguro, como um
        vendaval.
      </>
    ),
  },
  {
    title: "Eletricista",
    body: (
      <>
        Se faltar energia na empresa, por falhas nas instalações elétricas,
        enviamos um eletricista qualificado para fazer os reparos urgentes e
        restabelecer a energia do local, sempre que as condições permitirem.
      </>
    ),
  },
  {
    title: "Transporte de ambulância",
    body: (
      <>
        Se um ou mais funcionários efetivos ou visitantes do estabelecimento
        forem afetados fisicamente por situações cobertas pelo seguro, como um
        incêndio, garantimos o reembolso das despesas de transporte dessas
        pessoas, em ambulância ou veículo recomendado pelo médico responsável,
        até o hospital mais adequado ou residência.
      </>
    ),
  },
  {
    title: "Transferência / guarda de móveis",
    body: (
      <>
        Caso seja necessário desocupar o local onde a empresa funciona, devido a
        uma situação coberta pelo seguro que impeça as atividades ou por
        questões de segurança, retiramos os móveis e transportamos para o local
        indicado, em uma distância de até 50km.
      </>
    ),
  },
];

const AssistanceServiceSection = ({ serviceName }) => {
  return (
    <S.AssistanceServiceSectionContainer>
      <S.AssistanceServiceSectionContent className="container">
        <S.AssistanceServiceSectionHeader>
          <S.AssistanceServiceSectionTitle>
            Serviços de assistência
          </S.AssistanceServiceSectionTitle>

          <S.AssistanceServiceSectionDescription>
            Com o <strong>{serviceName}</strong>, você tem direito a serviços
            emergenciais para resolver os imprevistos do dia a dia.{" "}
            <strong>Confira quais são!</strong>
          </S.AssistanceServiceSectionDescription>
        </S.AssistanceServiceSectionHeader>

        <S.AssistanceServiceSectionList>
          <Accordion
            className="accordion-list"
            listItems={servicesList.slice(0, 5)}
          />
          <Accordion
            className="accordion-list"
            listItems={servicesList.slice(5, servicesList.length)}
          />
        </S.AssistanceServiceSectionList>
      </S.AssistanceServiceSectionContent>
    </S.AssistanceServiceSectionContainer>
  );
};

AssistanceServiceSection.propTypes = {
  serviceName: PropTypes.string,
};

AssistanceServiceSection.defaultProps = {
  serviceName: "",
};

export default AssistanceServiceSection;
